module.exports = __webpack_public_path__ + "static/media/r291.b71651a5.jpg";